<!-- 水果供求 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="pageInfoBlock" title="牛油果直供" label="INFORMARION" :tabList="tabList" :tabDefaultType="tabDefaultType" tabClass="list-tab-ul-1" count="10" v-on:queryPage="sggq_Req"/>
      </div>
<!--      <div class="content-col col-per-30">-->
<!--        <infoList title="推荐求购" label="HOT SERVICES" :showTitle="true" :showMore="false" :infoBlock="infoBlock11" :infoPage="infoPage1" v-on:queryPage="tjqg_Req" titleLength="18" count="8"/>-->
<!--      </div>-->
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import SgghInfo from '../module/SgghInfo'
import SgqgInfo from '../module/SgqgInfo'
import SgqgtjInfo from '../module/SgqgtjInfo'
import InfoList from '../block/InfoList'
import InfoBlock11 from '../block/InfoBlock11'
export default {
  name: 'Sggq01',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList': InfoList,
  },
  data() {
    return {
      msg: '',
      pageInfoBlock:SgghInfo,
      infoBlock11:SgqgtjInfo,
      infoPage:{},
      infoPage1:{},
      // tabList:[{title:"供货信息",type:'2'},{title:"求购信息",type:'1'}],
      tabList:[],
      tabDefaultType:'2'
    }
  },
  methods:{
    chooseTab:function(tabType){
      //this.selectedItem=clickedItem.title
      console.log("------回调成功"+tabType);

      this.sggq_Req({pageSize:7,page:1,type:tabType});
    },
    //水果供求
    sggq_Req(params){
          let that=this;
          if(params.type=="1"){
            that.pageInfoBlock=SgqgInfo;
          }else{
            that.pageInfoBlock=SgghInfo;
          }
      params.syncAvocado=2;
          let result={page:params};
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.tradeLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //推荐求购
    tjqg_Req(params){
      params.type='policy_library';
      let that=this;
      let result={page:params};
      params={page:1,pageSize:7,type:1};
      //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.tradeLists(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.list;
          result.page.total=res.data.total;

          that.infoPage1=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
        });

    },

  },
  created:function(){
    let params={page:1,pageSize:7,type:this.tabDefaultType};
    this.sggq_Req(params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Sggq01.vue